<template>
  <div className="app-wrapper app_content">
    <!-- <transition
    mode="out-in"
    name="custom-classes-transition"
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    :duration="{ enter: 100, leave: 100 }"

    > -->
    <router-view></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: "AppMain",
  components: {},
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app_content {
  padding: 10px 20px 20px 20px;
  text-align: left;
}
</style>
